import React from "react"
import { Waypoint } from "react-waypoint"
import { startSectionTracker, endSectionTracker } from "../actions"

const ScrollTracker = props => (
  <Waypoint
    onEnter={startSectionTracker(props.sectionTitle || "OTHER")}
    onLeave={endSectionTracker(props.sectionTitle || "OTHER")}
  >
    <div>{props.children}</div>
  </Waypoint>
)

export { ScrollTracker as default }



// WEBPACK FOOTER //
// ./assets/interview/components/ScrollTracker.js